import { I18n } from "i18n-js";
import translations from "../javascript/translations.json";

global.I18n = new I18n(translations);
global.I18n.pluralization["cs"] = function (count) {
  const key = count === 1 ? "one" : [2, 3, 4].indexOf(count % 10) >= 0 ? "few" : "other";
  return [key];
};
